import { Link } from "react-router-dom";
import { Users, Fuel, Settings2, BadgePercent, ShieldCheck } from "lucide-react";
import { inr } from "@/lib/brand";
import { RatingBadge } from "@/components/site/Stars";
import { HeartButton, CompareButton } from "@/components/site/CarActions";

export const savingsText = (tiers = []) => {
  const top = [...tiers].sort((a, b) => b.pct - a.pct || a.min_hours - b.min_hours)[0];
  if (!top) return "";
  const span = top.min_hours % 24 === 0 ? `${top.min_hours / 24}+ day` : `${top.min_hours}+ hr`;
  return `Save up to ${top.pct}% on ${span} trips`;
};

export function CarCard({ car, search = "", index = 0, savings = "" }) {
  return (
    <div className="fade-up group relative overflow-hidden rounded-[18px] border border-hc-sage bg-white shadow-[0_2px_14px_rgba(23,35,28,0.05)] transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_-16px_rgba(11,61,38,0.3)]"
      style={{ animationDelay: `${index * 60}ms` }} data-testid={`car-card-${car.id}`}>
      <Link to={`/cars/${car.id}${search}`} className="block" data-testid={`car-card-link-${car.id}`}>
        <div className="relative aspect-[3/2] overflow-hidden bg-hc-mint">
          <img src={car.images.front} alt={car.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
          <span className="absolute left-3 top-3 rounded-full bg-white/95 px-3 py-1 text-xs font-semibold text-hc-ink shadow-sm">{car.type}</span>
          {savings && (
            <span data-testid={`car-savings-${car.id}`} className="absolute bottom-3 left-3 flex items-center gap-1 rounded-full bg-hc-gold px-3 py-1 text-xs font-semibold text-hc-ink shadow-md">
              <BadgePercent className="h-3.5 w-3.5" />{savings}
            </span>
          )}
        </div>
        <div className="space-y-3 px-5 pb-4 pt-4">
          <div className="min-w-0">
            <p className="flex items-center gap-1.5 text-xs text-hc-slate">{car.year} · {car.variant}<ShieldCheck className="h-3.5 w-3.5 text-hc-success" aria-label="Verified" /></p>
            <h3 className="truncate font-display text-lg font-bold tracking-tight text-hc-ink">{car.name}</h3>
            <RatingBadge avg={car.rating_avg || 0} count={car.rating_count || 0} testId={`car-rating-${car.id}`} />
          </div>
          <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm text-hc-slate">
            <span className="flex items-center gap-1.5"><Users className="h-4 w-4" />{car.seats}</span>
            <span className="flex items-center gap-1.5"><Settings2 className="h-4 w-4" />{car.transmission}</span>
            <span className="flex items-center gap-1.5"><Fuel className="h-4 w-4" />{car.fuel}</span>
          </div>
        </div>
      </Link>
      <div className="flex items-end justify-between border-t border-hc-sage px-5 py-3.5">
        <p className="tabular"><span className="font-display text-2xl font-extrabold text-hc-green" data-testid={`car-price-${car.id}`}>{inr(car.price_per_hour)}</span><span className="text-sm text-hc-slate"> /hr</span></p>
        <CompareButton carId={car.id} small />
      </div>
      <HeartButton carId={car.id} className="absolute right-3 top-3" />
    </div>
  );
}
